import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// import Menu from './Menu'
import "../App/App.css"
import { checkUser } from '../helpers';
import MenuContainer from '../containers/MenuContainer';
import LoginContainer from '../containers/LoginContainer';
import DashboardContainer from '../containers/DashboardContainer';
import TerminalContainer from '../containers/TerminalContainer';
import PCSpecContainer from '../containers/PCSpecContainer';
import InstalledInfoSearchContainer from '../containers/InstalledInfoSearchContainer';
import SettingContainer from '../containers/SettingContainer';
import UserContainer from '../containers/UserContainer';
import VersionContainer from '../containers/VersionContainer';
import TerminalEditContainer from '../containers/TerminalEditContainer';
import TerminalNewContainer from '../containers/TerminalNewContainer';
import AccountContainer from '../containers/AccountContainer';
import AccountNewContainer from '../containers/AccountNewContainer';
import AccountEditContainer from '../containers/AccountEditContainer';
import WorkHistoryContainer from '../containers/WorkHistoryContainer';
import WorkHistoryStatusContainer from '../containers/WorkHistoryStatusContainer';
import StampContainer from '../containers/StampContainer';
import AttendStatusContainer from '../containers/AttendStatusContainer';
import AIAssistantContainer from '../containers/AIAssistantContainer';

const searchComponent = (p) => {
  switch (p) {
    case 'terminal':
      return TerminalContainer;
    case 'user':
      return UserContainer;
    case 'pcspec':
      return PCSpecContainer;
    case 'installed_info_search':
      return InstalledInfoSearchContainer;
    case 'history':
      return WorkHistoryContainer;
    case 'history-status':
      return WorkHistoryStatusContainer;
    case 'stamp':
      return StampContainer;
    case 'attend-status':
      return AttendStatusContainer;
    case 'version':
      return VersionContainer;
    case 'terminal-edit':
      return TerminalEditContainer;
    case 'terminal-new':
      return TerminalNewContainer;
    case 'accounts':
      return AccountContainer;
    case 'account-new':
      return AccountNewContainer;
    case 'account-edit':
      return AccountEditContainer;
    case 'setting':
      return SettingContainer;
    case 'login':
      return LoginContainer;
    default:
      return DashboardContainer;
  }
}

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => {
    const query = new URLSearchParams(props.location.search);
    const p = query.get('p'); // `${props.location.pathname}${props.location.search}`
    const Comp = searchComponent(p);
    return (
      checkUser()
        ? <div className="main-container">
          <MenuContainer path={p ? p : ""} />
          <Comp {...props} />
          <AIAssistantContainer />
        </div>
        : <Redirect to={{ pathname: '/index.html?p=login', state: { from: props.location } }} />
    )
  }} />
)
